import { render, staticRenderFns } from "./FluxRegaloStep2.vue?vue&type=template&id=17f2aca2"
import script from "./FluxRegaloStep2.vue?vue&type=script&lang=js"
export * from "./FluxRegaloStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports